module.exports = __webpack_public_path__ + "static/media/renovation.c3461d8e.png";